<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">Tesorería</li>
        <li class="breadcrumb-item active" aria-current="page">Retiros realizados a RG</li>
      </ol>
    </nav>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">Retiros a RG</div>
            <div class="card-body">

              <withdrawals-finder
                @onSubmit="search"
                label="Nombre o Razón social, RFC, email, IID, UID"></withdrawals-finder>

              <div class="withdrawals-investor" style="font-size: 10px">
                <vs-table :data="withdrawals">
                  <template slot="thead">
                    <vs-th>TRX</vs-th>
                    <vs-th>PID</vs-th>
                    <vs-th>Procesador</vs-th>
                    <vs-th>Trans. ID</vs-th>
                    <vs-th>Alias</vs-th>
                    <vs-th>Concepto</vs-th>
                    <vs-th>Monto</vs-th>
                    <vs-th>Status</vs-th>
                    <vs-th>F. Confirmación</vs-th>
                    <vs-th>Monto de fondeo</vs-th>
                    <vs-th>Factura</vs-th>
                    <vs-th>Meses</vs-th>
                    <vs-th style="width: 150px;">Factura</vs-th>
                  </template>
                  <template slot-scope="{data}">
                    <vs-tr
                      v-for="(wd, index) in data"
                      v-bind:key="index"
                      v-if="!(variant === 'projectTab' && d.trx_type === 'RI160')">
                      <vs-td>{{ wd.trx_type }}</vs-td>
                      <vs-td>{{ wd.project_id }}</vs-td>
                      <vs-td>{{ wd.payment_processor }}</vs-td>
                      <vs-td>{{ wd.trx_id }}</vs-td>
                      <vs-td>{{ wd.alias }}</vs-td>
                      <vs-td width="300px">{{ wd.concept }}</vs-td>
                      <vs-td align="right">{{ wd.amount|currency }}</vs-td>
                      <vs-td>{{ wd.status }}</vs-td>
                      <vs-td>{{ wd.trx_confirmation_date|humanizeDate }}</vs-td>
                      <vs-td>{{ wd.financed_amount|currency }}</vs-td>
                      <vs-td align="right">{{ wd.total_cost|currency }}</vs-td>
                      <vs-td align="right">{{ wd.term }}</vs-td>
                      <vs-td>
                        <template v-for="d in wd.details">
                          <div>
                          <template v-if="d.trx_type === 'RC162'">
                            <a-secure
                              :href="getInvoiceFileUri(d.invoice.xml_file)"
                              target="_blank"
                              rel="noopener"
                              v-if="d.rg_invoice_id !== null"
                            >
                              XML (A)
                            </a-secure>
                            <a-secure
                              :href="getInvoiceFileUri(d.invoice.pdf_file)"
                              target="_blank"
                              rel="noopener"
                              v-if="d.rg_invoice_id !== null"
                            >
                              PDF (A)
                            </a-secure>
                          </template>
                          <template v-if="d.trx_type === 'RC163'">
                            <a-secure
                              :href="getInvoiceFileUri(d.invoice.xml_file)"
                              target="_blank" rel="noopener"
                              v-if="d.rg_invoice_id !== null"
                            >
                              XML (B)
                            </a-secure>
                            <a-secure
                              :href="getInvoiceFileUri(d.invoice.pdf_file)"
                              target="_blank"
                              rel="noopener"
                              v-if="d.rg_invoice_id !== null"
                            >
                              PDF (B)
                            </a-secure>
                          </template>
                          <template v-if="d.trx_type === 'RC164'">
                            <a-secure
                              :href="getInvoiceFileUri(d.invoice.xml_file)"
                              target="_blank" rel="noopener"
                              v-if="d.rg_invoice_id !== null"
                            >
                              XML (B1)
                            </a-secure>
                            <a-secure
                              :href="getInvoiceFileUri(d.invoice.pdf_file)"
                              target="_blank" rel="noopener"
                              v-if="d.rg_invoice_id !== null"
                            >
                              PDF (B1)
                            </a-secure>
                          </template>
                          <a-secure
                            :href="getInvoiceFileUri(d.invoice.pdf_xml)"
                            target="_blank" rel="noopener"
                            v-if="d.rg_invoice_id !== null && (d.trx_type === 'RS160' || d.trx_type === 'RI160' || d.trx_type === 'RC160')"
                          >
                            XML
                          </a-secure>
                          <a-secure
                            :href="getInvoiceFileUri(d.invoice.pdf_file)"
                            target="_blank"
                            rel="noopener"
                            v-if="d.rg_invoice_id !== null && (d.trx_type === 'RS160' || d.trx_type === 'RI160' || d.trx_type === 'RC160')"
                          >
                            PDF
                          </a-secure>
                          </div>
                        </template>
                      </vs-td>
                      <template slot="expand">
                        <div class="con-expand-users w-full">
                          <vs-table :data="wd.details">
                            <template slot="thead">
                              <vs-th>TRX</vs-th>
                              <vs-th>Concepto</vs-th>
                              <vs-th>Monto</vs-th>
                              <vs-th>Estatus</vs-th>
                            </template>
                            <template slot-scope="{data}">
                              <vs-tr v-for="d in data" v-bind:key="'r-' + d.id" class="trx-child">
                                <vs-td>{{ d.trx_type }}</vs-td>
                                <vs-td>{{ d.concept }}</vs-td>
                                <vs-td align="right">{{ d.amount|currency }}</vs-td>
                                <vs-td>{{ d.status }}</vs-td>
                              </vs-tr>
                            </template>
                          </vs-table>
                        </div>
                      </template>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapState} from "vuex";

let WithdrawalsFinder = require('./withdrawals-finder').default;
import {RGWithdrawals} from "@/bl/withdrawals/rgWithdrawals";
import {AxiosErrorException} from '../functions/axiosErrorException';
import {humanizeDate} from "@/filters/momentTzConvert";
import ASecure from "@components/utils/aSecure";

export default {
  props: {
    variant: {
      type: String,
      default: 'withdrawsModule'
    },
    filters: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    ASecure,
    'withdrawals-finder': WithdrawalsFinder
  },
  data() {
    return {
      withdrawals: []
    }
  },
  async mounted() {
    try {
      this.getWithdrawals(this.filters);
    } catch (err) {
      swal('Ups!', AxiosErrorException(err), 'error')
    }
  },
  filters: {
    humanizeDate,
  },
  computed: {
    ...mapState('auth', ['user'])
  },
  methods: {
    getInvoiceFileUri(invoiceFilePath) {
      return this.$sanitizeUrl(`${this.StorageURL}/storage/private/rg-invoice/0/${invoiceFilePath}?access_token=${this.user.access_token}`)
    },
    search(e) {
      try {
        let filters = {...e, ...this.filters};
        this.getWithdrawals(filters);
      } catch (err) {
        swal('Ups!', AxiosErrorException(err), 'error')
      }
    },
    async getWithdrawals(filters) {
      this.$vs.loading();
      try {
        let wd = new RGWithdrawals();
        let res = await wd.get(filters)
        this.withdrawals = res.data;
      } finally {
        this.$vs.loading.close();
      }
    }
  }
}
</script>
<style scoped>
tbody.collapse {
  display: none;
}
</style>
